<template>
  <div class="card card-user">
    <div class="image">
      <img :src="'static/img/background/background-'+Math.floor((Math.random() * 4)+1)+'.jpg'" alt="...">
    </div>
    <div class="card-content">
      <div class="author">
        <img class="avatar border-white" v-if="userInfo.avatar" :src="userInfo.avatar"/>
        <img class="avatar border-white" v-else="" :src="'../../../static/img/faces/face-0.jpg'" width="10"/>
        <h4 class="title">{{userInfo.firstname}} {{userInfo.lastname}}
          <br>
          <a href="#">
            <small>{{userInfo.username}}</small>
          </a>
        </h4>
      </div>
      <p class="description text-center">
       {{userInfo.bio}}
      </p>
    </div>
    <hr>
    <div class="text-center">
      <div class="row">
        <div v-for="(info,index) in details" :class="getClasses(index)">
          <h5>{{info.title}}
            <br>
            <small>{{info.subTitle}}</small>
          </h5>
        </div>
      </div>

    </div>

  </div>
</template>
<script>
import api from '../api'
import moment from 'moment'
  export default {
    props: ['userInfo'],
    data () {
      return {
        random:1,
holsRemaining:'unknown',
        details: [
          {
            title: 'Role',
            subTitle: this.userInfo.role
          }
        ]
      }
    },
    methods: {
getHolidays(){
  api.getHolidays(this.userInfo.tt_id).then(r => {
   this.holsRemaining=r.data.allowances.filter(r =>{
     return  r.year==moment().year()
   })
   this.details.push({title:'Holidays',subTitle: this.holsRemaining[0].remaining+' used / '+this.holsRemaining[0].allowance+' left'})
  })
  
},
      getClasses (index) {
        const remainder = index % 3
        if (remainder === 0) {
          return 'col-md-4 col-md-offset-1'
        } else if (remainder === 2) {
          return 'col-md-5'
        } else {
          return 'col-md-4'
        }
      }
    },
    mounted() {
    //this.getHolidays()  
    }
  }
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/User/UserProfile/UserCard.vue